<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 22 22"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<!-- Free trial active: clock -->
		<template v-if="variant === 'trial'">
			<path
				d="M11 5.5V11L14.6667 12.8333"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.9987 20.1654C16.0613 20.1654 20.1654 16.0613 20.1654 10.9987C20.1654 5.93609 16.0613 1.83203 10.9987 1.83203C5.93609 1.83203 1.83203 5.93609 1.83203 10.9987C1.83203 16.0613 5.93609 20.1654 10.9987 20.1654Z"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</template>

		<!-- Free trial ended / payment failed: exclamation circle -->
		<template v-else-if="variant === 'trial_ended' || variant === 'payment_failed'">
			<path
				d="M10.9987 20.1654C16.0613 20.1654 20.1654 16.0613 20.1654 10.9987C20.1654 5.93609 16.0613 1.83203 10.9987 1.83203C5.93609 1.83203 1.83203 5.93609 1.83203 10.9987C1.83203 16.0613 5.93609 20.1654 10.9987 20.1654Z"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M11 7.33203V10.9987"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M11 14.668H11.0086"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</template>

		<!-- Active: check circle -->
		<template v-else-if="variant === 'active'">
			<path
				d="M10.9987 20.1654C16.0613 20.1654 20.1654 16.0613 20.1654 10.9987C20.1654 5.93609 16.0613 1.83203 10.9987 1.83203C5.93609 1.83203 1.83203 5.93609 1.83203 10.9987C1.83203 16.0613 5.93609 20.1654 10.9987 20.1654Z"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M8.25 11.0013L10.0833 12.8346L13.75 9.16797"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</template>

		<!-- Expiring soon: warning triangle -->
		<template v-else-if="variant === 'expiring' || variant === 'trial_expiring'">
			<path
				d="M19.9187 16.501L12.5854 3.66769C12.4255 3.38554 12.1936 3.15086 11.9134 2.98758C11.6332 2.82431 11.3147 2.73828 10.9904 2.73828C10.6661 2.73828 10.3476 2.82431 10.0674 2.98758C9.78718 3.15086 9.5553 3.38554 9.3954 3.66769L2.06207 16.501C1.90044 16.7809 1.81569 17.0986 1.81641 17.4218C1.81713 17.745 1.90328 18.0623 2.06614 18.3415C2.22901 18.6207 2.46279 18.8519 2.74379 19.0116C3.02479 19.1713 3.34303 19.2539 3.66624 19.251H18.3329C18.6546 19.2507 18.9705 19.1657 19.2489 19.0047C19.5274 18.8437 19.7585 18.6122 19.9192 18.3335C20.0799 18.0549 20.1644 17.7389 20.1644 17.4172C20.1643 17.0956 20.0796 16.7796 19.9187 16.501Z"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M11 8.25V11.9167"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M11 15.582H11.0103"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</template>

		<!-- Expired: X circle -->
		<template v-else-if="variant === 'expired'">
			<path
				d="M10.9987 20.1654C16.0613 20.1654 20.1654 16.0613 20.1654 10.9987C20.1654 5.93609 16.0613 1.83203 10.9987 1.83203C5.93609 1.83203 1.83203 5.93609 1.83203 10.9987C1.83203 16.0613 5.93609 20.1654 10.9987 20.1654Z"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M13.75 8.25L8.25 13.75"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M8.25 8.25L13.75 13.75"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</template>

		<!-- Fallback: trial icon -->
		<template v-else>
			<path
				d="M11 5.5V11L14.6667 12.8333"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.9987 20.1654C16.0613 20.1654 20.1654 16.0613 20.1654 10.9987C20.1654 5.93609 16.0613 1.83203 10.9987 1.83203C5.93609 1.83203 1.83203 5.93609 1.83203 10.9987C1.83203 16.0613 5.93609 20.1654 10.9987 20.1654Z"
				:stroke="strokeColor"
				:stroke-width="strokeWidth"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</template>
	</svg>
</template>

<script>
const VARIANT_COLORS = {
	trial: '#1E3B4C',
	trial_expiring: '#623400',
	trial_ended: '#531306',
	payment_failed: '#531306',
	active: '#164028',
	expiring: '#623400',
	expired: '#531306'
}

export default {
	name: 'IconSubscriptionStatus',
	props: {
		variant: {
			type: String,
			required: true,
			validator: (v) =>
				['trial', 'trial_expiring', 'trial_ended', 'payment_failed', 'active', 'expiring', 'expired'].includes(v)
		},
		size: {
			type: [Number, String],
			default: 22
		},
		color: {
			type: String,
			default: null
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.83333
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		strokeColor() {
			return this.color ?? VARIANT_COLORS[this.variant] ?? 'currentColor'
		}
	}
}
</script>
